import { Tag } from "@chakra-ui/react";
import { skipToken } from "@reduxjs/toolkit/dist/query";
import { useTranslation } from "react-i18next";
import { useLookUpInviteEmailAccountQuery } from "../../../../../../autogen/bff-api";

export const EmailInviteAccountTag = ({
  eventId,
  email,
  canLookUp,
}: {
  eventId: string;
  email: string;
  canLookUp: boolean;
}) => {
  const { t } = useTranslation();
  const { data, isSuccess } = useLookUpInviteEmailAccountQuery(canLookUp ? { eventId, email } : skipToken);
  if (!isSuccess) return null;
  return <Tag size="sm">{data.personId ? t("Has an account") : t("Not registered")}</Tag>;
};
